"use strict";
import { ConnectionProvider } from "hooks/useConnect";
import { useWalletCapabilitiesStateEffect } from "state/walletCapabilities/hooks/useWalletCapabilitiesStateEffect";
import { WagmiProvider } from "wagmi";
export function createWeb3Provider(params) {
  const { wagmiConfig, reconnectOnMount = true, includeCapabilitiesEffects = true } = params;
  const WalletCapabilitiesEffects = () => {
    useWalletCapabilitiesStateEffect();
    return null;
  };
  const Provider = ({ children }) => <WagmiProvider config={wagmiConfig} reconnectOnMount={reconnectOnMount}><ConnectionProvider>{includeCapabilitiesEffects && <WalletCapabilitiesEffects />}{children}</ConnectionProvider></WagmiProvider>;
  Provider.displayName = "Web3Provider";
  return Provider;
}
